import { mainApi } from "services/main";
import { GetAllTemplatesRequest, GetAllTemplatesResponse } from "./definitions";
import { TAGS } from "services/main/constants";

const extendedApi = mainApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllTemplates: builder.query<
      GetAllTemplatesResponse,
      GetAllTemplatesRequest
    >({
      query: (request: GetAllTemplatesRequest) => ({
        url: `/v1/lts/templates?userAlias=${request.userAlias}`,
        method: "GET",
      }),
      providesTags: [TAGS.AllTemplates],
    }),
  }),
  overrideExisting: false,
});

export const { useGetAllTemplatesQuery } = extendedApi;
